import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Save as SaveIcon,
  Delete as DeleteIcon,
  NoteAdd as NoteAddIcon,
  Visibility as VisibilityIcon
} from '@mui/icons-material';
import { ActionsButtons } from "components/CustomButtons/ActionsButtons";
import { ModalV2 } from "components/Modal/ModalV2";
import { NationalNotesView } from "./NationalNotesView";
import ShipmentForm from "./ShipmentForm";
import { useRuleValidator } from "hooks/useRuleValidator";
import { useToggle } from "hooks/useToggle";
import { PERMISSIONS } from "router/permissions";
import { deleteShipment, deleteLocalShipment } from "redux/actions/inventories/inventShipmentsActions";

const ShipmentActionsCell = ({ original }) => {
  const { id, shipmentNumber, creLicense, idCarrier, shipperTruck } = original;
  const { nationalNotes } = useSelector(({ inventories }) => inventories);
  const { isLoadingComp } = useSelector(({ search }) => search);
  const dispatch = useDispatch();
  const {
    INVENTORIES_SHIPMENTS_DELETE,
    DISOUNT_SHIPMENTS
  } = PERMISSIONS
  const deletePermission = useRuleValidator(INVENTORIES_SHIPMENTS_DELETE);
  const notePermission = useRuleValidator(DISOUNT_SHIPMENTS);
  const [openNotes, setOpenNotes] = useToggle();
  const [openShipment, setOpenShipment] = useToggle();
  const [openDelete, setOpenDelete] = useToggle();
  // Indicador de que la información ya fue guardada
  const isReadOnly = !!creLicense && !!idCarrier && !!shipperTruck;

  const handleDelete = async () => {
    // Si el embarque ya se guardó en el backend, se elimina vía API.
    // Si solo existe en el estado local, se remueve únicamente del store.
    const isDeleted = isReadOnly
      ? await dispatch(deleteShipment(id))
      : dispatch(deleteLocalShipment(id));
    if (isDeleted) setOpenDelete();
  };

  const buttons = [
    {
      Icon: isReadOnly ? VisibilityIcon : SaveIcon,
      color: 0,
      onClick: setOpenShipment,
      tooltip: `${isReadOnly ? 'Ver' : 'Guardar'} embarque`,
    },
    {
      Icon: DeleteIcon,
      color: 3,
      onClick: setOpenDelete,
      tooltip: "Eliminar embarque",
      validation: deletePermission,
    },
    {
      Icon: NoteAddIcon,
      color: 0,
      onClick: setOpenNotes,
      tooltip: "Agregar notas nacionales",
      validation: notePermission && (nationalNotes?.length > 0 || original?.nationalNotes?.length > 0),
    },
  ];

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, flexWrap: 'wrap' }}>
      <ActionsButtons buttons={buttons} />
      {openShipment && (
        <ShipmentForm
          title={`${isReadOnly ? 'E' : 'Guardar e'}mbarque ${shipmentNumber}`}
          open={openShipment}
          setOpen={setOpenShipment}
          data={original}
          isReadOnly={isReadOnly}
        />
      )}
      <ModalV2 open={openNotes}
        onClose={setOpenNotes}
        title="Notas nacionales Disponibles"
        toRight
        halfScreen
      >
        <NationalNotesView shipmentId={id} onClose={setOpenNotes} />
      </ModalV2>
      <ModalV2
        open={openDelete}
        onClose={setOpenDelete}
        title={`¿Seguro desea eliminar el embarque ${shipmentNumber}?`}
        justConfirm
        onSubmit={handleDelete}
        confirmText="Eliminar"
        confirmColor="danger"
        isLoading={isLoadingComp?.deleteShipment}
      />
    </div>
  );
};

export default ShipmentActionsCell;